import {all, race, delay, fork, call, put, take, select, takeEvery, cancel} from 'redux-saga/effects';
import apiServer from '../../Api/Backend'
import {
  bytesToGB,
  kaytekSpeedtestFixedBudgetRun,
} from '../../Helpers/speedtestFrontend'
import {ttsSpeakToken} from '../audio/actions'
import {generatePlaceholderMessage, randomUUID, truncateMiddle} from '../../Helpers/utils'
import {
  AUDIO_REDUCER,
  AUDIO_SET_STT_ENABLED,
  BOT_NAME,
  CHAT, DOWNLOAD_MBPS,
  GENERAL_REDUCER,
  REFLECTED_CHAT,
  STT_ENABLED, UPLOAD_MBPS,
  VNSTAT_URL
} from '../consts'
import {setIsShowPhotoOpen, startPhotoshoot} from '../video/actions'
import {
  getNewSessionIdAction,
  playKeystroke,
  receiveTextStream,
  setAnimation,
  setEndOfStream,
  setPlaceHolderMessage,
  startingCompletion,
  terminate,
  turnPlaceHolderMessageAction,
  newSessionIdSuccess,
  receiveTextStreamReflected,
  setEndOfStreamReflected,
  getGeneralMetaDataResult,
  getGeneralMetaData,
  setShouldFocusSendButton, setNetworkSpeed, setNetworkUsage, setIsShowingNetworkStats,
} from './actions'
import {
  GET_GENERAL_META_DATA,
  GET_NEW_SESSION_ID,
  NEW_SESSION_ID_SUCCESS,
  ON_APP_LOAD,
  PREDICT,
  SCROLL_TEXT,
  TOPN_BROWSING_DELAY,
  TERMINATE,
  TURN_PLACEHOLDER_MESSAGE,
  SPEED_MODULATION_DELAY,
  MINIMAL_DEBUG_DELAY,
  TOPN_AFTER_SELECTION_DELAY,
  TIME_TO_WAIT_FOR_NEW_SESSION_ID,
} from './consts'
import {store} from '../store'

// eslint-disable-next-line require-yield
function* scrollTextSaga() {
  try {
    const el = document.getElementById('arnoldText')
    if (!el) return

    // 2 rAFs: one to let React commit, one to let layout-effects-triggered rerender commit
    yield call(() => new Promise(requestAnimationFrame))
    yield call(() => new Promise(requestAnimationFrame))

    el.scrollTop = el.scrollHeight
  } catch (e) {
    console.log('error in scrollTextSaga', { e })
  }
}


function* predictSaga(action) {
  try {
    console.log('predictSaga', truncateMiddle(JSON.stringify(action)))

    const textPrompt = typeof action.payload === 'string' ? action.payload : action.payload.content;
    if (typeof action.payload === 'string' && !textPrompt?.trim()) {
      return;
    }
    if (['STOP MIC'].includes(textPrompt.trim().toUpperCase())) {
      sessionStorage.setItem('NO_AUDIO_CAPTURING', 'true')
      yield put(receiveTextStream({
        word: 'Mic stopped. reboot to start again',
        predictionUUID: randomUUID()
      }))
      return
    }
    yield put(startingCompletion(textPrompt, action.initiator))
    yield put(getGeneralMetaData())
    yield put(setShouldFocusSendButton(true))

    const dispatch = store.dispatch
// Assumes apiServer and dispatch(receiveTextStream(...)) are in scope
    const publishChunkCb = (predictionUUID) => async (strFull) => {
      const meta = [];

      // Matches: {meta: "value"} then a tail with no braces (same as [^{}]*)
      // Captures: 1) meta value, 2) tail text
      const re = /\{meta: "([^"]+)"\}([^{}]*)/g;

      let lastIndex = 0;
      let match;

      // helper to dispatch any gap text between meta chunks
      const dispatchGap = (from, to) => {
        if (to > from) {
          const gap = strFull.slice(from, to);
          if (gap.length) {
            // emit unmatched text as-is
            dispatch(receiveTextStream({ word: gap, predictionUUID, meta:[] }));
          }
        }
      };

      while ((match = re.exec(strFull)) !== null) {
        const matchStart = match.index;
        const matchEnd = re.lastIndex;

        // emit any unmatched text before this meta-chunk
        dispatchGap(lastIndex, matchStart);

        const metaValue = match[1];
        const tail = match[2];

        // Mirror your meta accumulation behavior
        if (metaValue === 'take a photo') {
          meta.push({ action: 'take a photo' });
        } else if (metaValue.startsWith('show a photo=')) {
          const basePhotoUrl = metaValue.split('=')[1];
          const photoUrl = apiServer.getServiceUrl() + basePhotoUrl;
          meta.push({ action: 'show photo', url: photoUrl });
        } else if (metaValue.startsWith('topn=')) {
          const topnItems = metaValue.split('=')[1].split(',');
          // Keep your original guard: only proceed if there are items
          // and the emitted tail doesn't start with "{meta:"
          if (topnItems.length > 0 && !tail.startsWith('{meta:')) {
            const randomIndex = Math.floor(Math.random() * (topnItems.length + 1));
            topnItems.splice(randomIndex, 0, tail);
            const uniqueTopN = [...new Set(topnItems)];
            meta.push({ action: 'show topn', topn: uniqueTopN, selectedToken: tail });
          }
        } else {
          console.log('unknown meta value:', metaValue);
        }

        dispatch(receiveTextStream({ word: tail, predictionUUID, meta }));

        lastIndex = matchEnd;
      }

      // emit any trailing unmatched text after the final meta-chunk
      dispatchGap(lastIndex, strFull.length);
    };

    const endOfStreamCb = (predictionUUID) => async () => {
      dispatch(setEndOfStream({endOfStream: true, predictionUUID}))
    }
    yield put(setAnimation(Math.round(Math.random() * 4 + 1)))  // 1-5

    // create random UUID for the prediction
    const predictionUUID = randomUUID()

    yield call(apiServer.postWithStreamResponse, '/textCompletion',
      {
        prompt: action.payload
      },
      publishChunkCb(predictionUUID),
      endOfStreamCb(predictionUUID),
    )
  } catch (e) {
    console.error('error in predictSaga', {e})
  }
}
function *turnPlaceholderMessageSaga() {
  try {
    const botName = yield select(state => state.getIn([GENERAL_REDUCER,BOT_NAME]))
    const isSTTEnabled = yield select(state => state.getIn([AUDIO_REDUCER,STT_ENABLED]))
    const message = generatePlaceholderMessage({botName,isSTTEnabled})
    yield put(setPlaceHolderMessage(message))
  } catch (e) {
    console.log('error in turnPlaceHolderMessage', {e})
  }
}

function* onAppLoadGeneralSaga() {
  sessionStorage.removeItem('arnoldSessionId')

  yield put(getNewSessionIdAction())

  if (!sessionStorage.getItem('arnoldSessionId')) {
    console.log('sessionId not found, waiting for it')
    yield race({
      sessionReady: take(NEW_SESSION_ID_SUCCESS),
      timeout: delay(TIME_TO_WAIT_FOR_NEW_SESSION_ID)
    })
  }
  if (!sessionStorage.getItem('arnoldSessionId')) {
    console.error('sessionId not found, the race timed out')
    return
  } else {
    console.log('sessionId found', sessionStorage.getItem('arnoldSessionId'))
  }
  yield put(getGeneralMetaData())
  yield put(terminate())

  setInterval(
    () => store.dispatch(turnPlaceHolderMessageAction()),
    5 * 60 * 1_000
  )

  yield fork(networkSpeedLoopSaga)
  yield fork(networkUsageToastLoopSaga)
}

function* getGeneralMetaDataSaga() {
  try {
    const metaData = yield call(apiServer.get, '/metaData')
    if (metaData.botName === 'Unknown') {
      metaData.botName = 'Arnold'
    }
    yield put(getGeneralMetaDataResult(metaData))
  } catch (e) {
    console.log('error in getGeneralMetaDataSaga', {e})
  }
}

function *terminateSaga() {
  try {
    yield call(apiServer.post, '/terminate')
  } catch (e) {
    console.log('error in terminateSaga', {e})
  }
}

function* getNewSessionIdSaga() {
  console.log('getNewSessionIdSaga')
  try {
    const arnoldSessionId = yield call(apiServer.get, '/sessions/new', {}, false)
    sessionStorage.setItem('arnoldSessionId', arnoldSessionId.sessionId)
    yield put(newSessionIdSuccess())
  } catch (e) {
    console.log('error in getNewSessionId', {e})
  }
}

let isShiftPressed = false;

document.addEventListener('keydown', (event) => {
  if (event.key === 'Shift') {
    isShiftPressed = true;
  }
});

document.addEventListener('keyup', (event) => {
  if (event.key === 'Shift') {
    isShiftPressed = false;
  }
});


function* chatSpeedModulatorSaga() {
  while (true) {
    {
      // iterate over all chat entries and if the entry is an assistant entry,
      // and if the reflected chat entry is smaller than the chat entry,
      // emit receiveTextStreamReflected action with a single character from the chat entry
      // (might as well that more characters exist in the chat, not yet reflected)
      // it is important to iterate over ALL chat entries, because some entries
      // might still be streaming and are not necessarily the last ones
      const chat = yield select(state => state.getIn([GENERAL_REDUCER,CHAT]))
      const reflectedChat = yield select(state => state.getIn([GENERAL_REDUCER,REFLECTED_CHAT]))
      for (let i = chat.size-1; i >=0 && i>=chat.size-2; i--) { // always take last 2 chunks (typically user + assistant)
        const chatEntry = chat.get(i)
        if (chatEntry.get('role') === 'assistant') {
          const predictionUUID = chatEntry.get('predictionUUID')
          const reflectedChatEntry = reflectedChat.find(entry => entry.get('predictionUUID') === predictionUUID)
          const meta = chatEntry.get('meta').toJS() || []
          // if the reflected chat entry is smaller than the chat entry,
          // or the reflected meta object has less keys than than the chat entry meta object,
          // reflect a single character
          if (!reflectedChatEntry || (reflectedChatEntry?.get('text')?.length < chatEntry?.get('text')?.length)
            || (reflectedChatEntry?.get('meta')?.size < chatEntry?.get('meta')?.size)) {
            // getting one character to reflect, some more characters might exist in the chat, not yet reflected
            const chatEntryIndex = reflectedChatEntry?.get('text').length || 0
            let strToReflect = chatEntry.get('text')[chatEntryIndex] || ''

            let topN = []
            let selectedTopNIndex = -1
            let isTopNPanelOpen = false
            // iterate on all metas using for loop, and check if chatEntryIndex matches any of the metas
            for (const item of meta) {
              if (item.index === chatEntryIndex) {
                switch (item.action) {
                  case 'take a photo':
                    console.log('take a photo meta', item)
                    yield put(startPhotoshoot())
                    break
                  case 'show photo':
                    console.log('show photo meta', item)
                    if (item.url) {
                      yield put(setIsShowPhotoOpen(true, item.url))
                    } else {
                      console.warn('no url in show photo meta', item)
                    }
                    break
                  case 'show topn':
                    if (item.topn && item.topn.length > 0 && item.selectedToken) {
                      topN = item.topn
                      isTopNPanelOpen = true
                      yield put(receiveTextStreamReflected({predictionUUID, topN, isTopNPanelOpen}))
                      for (let j = 0; j < item.topn.length; j++) {
                        selectedTopNIndex = j
                        yield put(receiveTextStreamReflected({predictionUUID, selectedTopNIndex}))
                        // if the current item is the one, break the loop
                        if (item.topn[j] === item.selectedToken) {
                          if (!isShiftPressed) {
                            yield delay(TOPN_AFTER_SELECTION_DELAY)
                          } else {
                            yield delay(MINIMAL_DEBUG_DELAY)
                          }
                          strToReflect = item.selectedToken
                          break
                        }
                        yield put(playKeystroke())
                        if (!isShiftPressed) {
                          yield delay(TOPN_BROWSING_DELAY)
                        } else {
                          yield delay(MINIMAL_DEBUG_DELAY)
                        }
                      }
                      isTopNPanelOpen = false
                      yield put(receiveTextStreamReflected({predictionUUID, isTopNPanelOpen}))
                    }
                    break
                  default:
                    console.warn('unknown action in meta', item)
                }
              }
            }
            yield put(receiveTextStreamReflected({word: strToReflect, predictionUUID, meta, topN, selectedTopNIndex, isTopNPanelOpen}))
            yield put(ttsSpeakToken(strToReflect))
            yield put(playKeystroke())
          } else {
            // no new characters to reflect, should I update endOfStream?
            const endOfStream = chatEntry.get('endOfStream')
            const endOfStreamReflected = reflectedChatEntry.get('endOfStream')
            if (endOfStream && !endOfStreamReflected) {
              // if the chat entry is marked as end of stream, reflect it
              yield put(setEndOfStreamReflected({endOfStream: true, predictionUUID}))
              yield put(ttsSpeakToken('',true))
            }
          }
        }
      }
    }
    if (!isShiftPressed) {
      yield delay(SPEED_MODULATION_DELAY)
    } else {
      yield delay(MINIMAL_DEBUG_DELAY)
    }
  }
}

function* networkSpeedLoopSaga() {
  const cfg = {
    monthlyBudgetBytes: 200 * 1024 * 1024,
    expectedRunsPerDay: 48,
  }

  while (true) {
    try {
      const r = yield call(kaytekSpeedtestFixedBudgetRun, cfg)
      yield put(setNetworkSpeed({
        [UPLOAD_MBPS]: r?.measured?.upload?.mbps ?? null,
        [DOWNLOAD_MBPS]: r?.measured?.download?.mbps ?? null,
      }))
    } catch (e) {
      console.log('error in networkSpeedLoopSaga', { e })
    }

    yield delay(30 * 60 * 1_000)
  }
}

function* networkUsageToastLoopSaga() {
  yield delay(10000)  // server not ready

  while (true) {
    try {
      const r = yield call(fetch, VNSTAT_URL, { method: "GET", cache: "no-store" })
      const j = yield call([r, r.json])

      const uploadGB = bytesToGB(j?.tx_bytes)
      const downloadGB = bytesToGB(j?.rx_bytes)

      yield put(setNetworkUsage({
        uploadGB,
        downloadGB,
        measuredAt: Date.now(),
        raw: { tx_bytes: j?.tx_bytes ?? null, rx_bytes: j?.rx_bytes ?? null },
      }))

      yield put(setIsShowingNetworkStats(true))
      yield delay(4_000)
      yield put(setIsShowingNetworkStats(false))
    } catch (e) {
      if (Math.random()<0.001) {
        console.log('gpt0202', 'vnstat usage poll failed (random logging)', {
          url: VNSTAT_URL,
          name: e?.name,
          message: e?.message,
          origin: window.location?.origin,
        })
      }
    }
    yield delay(56_000)
  }
}

function* watchGeneralSagas() {
  yield takeEvery(PREDICT, predictSaga)
  yield takeEvery(SCROLL_TEXT, scrollTextSaga)
  yield takeEvery(GET_GENERAL_META_DATA, getGeneralMetaDataSaga)
  yield takeEvery(ON_APP_LOAD, onAppLoadGeneralSaga)
  yield takeEvery(TERMINATE, terminateSaga)
  yield takeEvery([TURN_PLACEHOLDER_MESSAGE,AUDIO_SET_STT_ENABLED], turnPlaceholderMessageSaga)
  yield takeEvery(GET_NEW_SESSION_ID, getNewSessionIdSaga)
  yield fork(chatSpeedModulatorSaga)

}

export default function* generalSaga() {
  yield all([watchGeneralSagas()])
}
